import { getWindow } from './browserVars';
import uuid from './uuid';
import { buildTrackingId, submitMetric } from './analytics';
import YouTubeAPI from './apiYouTube';

const videoPlayed = {};

const onStateChange = async (event) => {
  const api = await YouTubeAPI;
  const frameId = event.target.getIframe().getAttribute('id');
  const playerStatus = event.data;
  // Have video play already been tracked
  if (!videoPlayed[frameId]) {
    switch (playerStatus) {
      case api.PlayerState.PLAYING:
      case api.PlayerState.PAUSED:
        videoPlayed[frameId] = true;
        try {
          const videoTitle = event.target.getVideoData().title;
          const trackingId = buildTrackingId([
            `video played - ${videoTitle}`,
          ]);
          submitMetric(trackingId);
        } catch (e) {
          // Failed to submit the analytics
          // Just silently let the error go through
        }

        break;
      default:
    }
  }
};

const getPlayer = async (id) => {
  const api = await YouTubeAPI;
  if (api) {
    const YTPlayer = api.Player;
    return new YTPlayer(id, {
      playerVars: {
        autoplay: 0,
        controls: 1,
        disablekb: 1,
        enablejsapi: 1,
        showinfo: 0,
      },
      events: {
        onStateChange,
      },
    });
  }
  return null;
};

const getYouTubeId = (embeddedUrl) => {
  const regex = /.*?youtube.*?\/embed\/(.*?)(?=($|\/|\?))/gi;
  const queryBreakdown = regex.exec(embeddedUrl);
  return queryBreakdown[1];
};

const processEmbeddedVideoIFrame = (vidElem) => {
  const browserWindow = getWindow();
  if (vidElem && browserWindow) {
    const src = vidElem.getAttribute('src');
    const youtubeId = getYouTubeId(src);
    if (youtubeId) {
      let elemId = vidElem.getAttribute('id');
      if (!elemId) {
        elemId = uuid();
      }

      const updateIFrame = () => {
        if (src && !src.includes('enablejsapi=true')) {
          vidElem.setAttribute('src', `${src}${src.includes('?') ? '&' : '?'}enablejsapi=true`);
        }
        vidElem.setAttribute('id', elemId);
        videoPlayed[elemId] = false;

        browserWindow.setTimeout(() => getPlayer(elemId));
      };

      if (browserWindow.requestAnimationFrame) {
        browserWindow.requestAnimationFrame(updateIFrame);
      } else {
        updateIFrame();
      }
    }
  }
};

const addYouTubeVideoTracking = async (rootElement) => {
  const browserWindow = getWindow();
  if (rootElement && browserWindow) {
    const iframes = Array.from(rootElement.querySelectorAll('iframe[src*="youtube"]'));
    iframes.forEach((vidElem) => { processEmbeddedVideoIFrame(vidElem); });
  }
};

export default addYouTubeVideoTracking;
export {
  getYouTubeId,
};
